import script from "./ModuleSetupNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleSetupNotice.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleSetupNotice.vue?vue&type=style&index=0&id=52982d53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52982d53"]])

export default __exports__